import styled from 'styled-components';
import theme from 'theme';

export const Card = styled.section`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.border_light_gray};
    border-radius: 3px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
`;

export const CardHeader = styled.header`
    border-bottom: 1px solid ${theme.colors.gray_lightest};
    border-left: 2px solid ${theme.colors.main};
    padding: 12px 24px;
`;

export const CardTitle = styled.h2`
    font-family: ${theme.fonts.regular};
    font-size: 14px;
    margin: 0;
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const CardBody = styled.div`
    padding: 12px;
`;
